import { createStore } from 'satcheljs';
export default createStore('linkPreviewOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map